// src/pages/ItemStock/index.js
import React, { useEffect, useRef,useState  } from "react";
import { useDispatch, useSelector } from "react-redux";
import { App, Button, Card, Grid, Typography,  Drawer, Tooltip, Flex } from "antd";
import { ArrowLeftOutlined, DownloadOutlined, PrinterOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { fetchItemStockReport } from "./ItemStockThunk";
import ItemStockTable from "./components/ItemStockTable";
import ItemStockFilters from "./components/ItemStockFilters";
import ReportDom from "../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router-dom";
import { exportItemStockReportCsv } from "./components/exportItemStockReportCsv";

const { Title } = Typography;

const ItemStockReport = () => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
 const { filters, list } = useSelector((state) => state.itemStock); // ← added list

  const reportRef = useRef(null);
  const [helpOpen, setHelpOpen] = useState(false);

  const navigate = useNavigate();
  const handleNavigateToBack = () => {
    navigate(-1);
  };

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Item Stock Report",
    removeAfterPrint: true,
    pageStyle: "@page { size: A4 landscape; margin: 12mm; }",
    print: async (iframe) => {
      // Forces landscape even when a global portrait @page rule (print.css)
      // gets copied into the iframe after pageStyle and would otherwise win
      // the cascade. Appending here happens last, guaranteeing it wins.
      const doc = iframe.contentDocument;
      const style = doc.createElement("style");
      style.textContent = "@page { size: A4 landscape !important; margin: 12mm; }";
      doc.head.appendChild(style);
      iframe.contentWindow.print();
    },
  });
  const handleDownloadCsv = () => {
    exportItemStockReportCsv({
      list,
      filters,
      title:    "Item Stock Report",
      filename: "item_stock_report",
    });
  };

  const hasData = list.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToBack}
                style={{ marginRight: 8 }}
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
           

                  <Title level={4} >
                    Item Stock Report
                  </Title>
                </div>

                <Tooltip title="Help">
                  <Button
                    type="text"
                    icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
                    onClick={() => setHelpOpen(true)}
                  />
                </Tooltip>
              </div>
          }
            extra={
            // ← replaced single Button with Flex + two buttons
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <ItemStockFilters />

        <Card className="shadow-md rounded-xl">
          <ItemStockTable messageApi={message} />
        </Card>
      </App>

      {/* Hidden Print Layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Item Stock Report"
          orientation="landscape"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <ItemStockTable pagination={false} printMode={true} />
          )}
        />
      </div>
      <Drawer
  title="Item Stock Report Help"
  open={helpOpen}
  onClose={() => setHelpOpen(false)}
  width={420}
  styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
>
  <div style={{ lineHeight: 1.8 }}>
    <h2
      style={{
        fontSize: "18px",
        fontWeight: 600,
        marginBottom: "12px",
        marginLeft: "8px",
      }}
    >
      Item Stock Report
    </h2>

    <p
      style={{
        color: "#555",
        marginBottom: "16px",
        marginLeft: "8px",
      }}
    >
      The Item Stock Report module is used to view and analyze current
      inventory stock details within the ERP system. It helps track
      item availability, stock movement, and inventory balances for
      operational and reporting purposes.
    </p>

    <div
      style={{
        background: "#f5f5f5",
        padding: "14px",
        borderRadius: "8px",
        marginBottom: "16px",
      }}
    >
      <strong>Steps to View Item Stock Report</strong>

      <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
        <li>Open <strong>Inventory → Item Stock Report</strong></li>
        <li>Select required filters if needed</li>
        <li>Search item or stock details</li>
        <li>Review available stock quantities</li>
        <li>Verify batch and warehouse details if applicable</li>
        <li>Analyze stock values and inventory balances</li>
        <li>Use Print option to generate report copy if required</li>
      </ol>
    </div>

    <div
      style={{
        background: "#fafafa",
        border: "1px solid #eee",
        padding: "14px",
        borderRadius: "8px",
      }}
    >
      <strong>Important Notes</strong>

      <ul
        style={{
          paddingLeft: "18px",
          marginTop: "10px",
          color: "#666",
        }}
      >
        <li>Stock quantities update automatically based on transactions.</li>
        <li>Filters can be used to narrow report results.</li>
        <li>Printed reports reflect current inventory data.</li>
        <li>Verify stock balances regularly for inventory accuracy.</li>
      </ul>
    </div>
  </div>
</Drawer>
    </div>
  );
};

export default ItemStockReport;
